import {
  get,
  post,
  hapus,
  update,
  upload,
  download,
} from './helpers'

function getAllTiket(page, data) {
  return get(`/tiket/list/${page}`, data)
}

function getAllTiketHistori(page, data) {
  return get(`/tiket/list-histori/${page}`, data)
}

function getAllTiketByProyek(page, proyekId) {
  return get(`/tiket/list/${page}`, { proyek_id: proyekId })
}

function getAllTiketByUser(page, userId) {
  return get(`/tiket/list/${page}`, { user_id: userId })
}

function getAllKegiatanSidebar(perPage) {
  return get(`/tiket/list/${perPage}`)
}

function getAllAplikasi() {
  return get('/aplikasi/list')
}

function getTiket(tiketId, data) {
  return get(`/tiket/${tiketId}`, data)
}

function getUserTiket(tiketId, jenisUser, data) {
  return get(`/tiket/list-user/${tiketId}/${jenisUser}`, data)
}

function getListUserTiket(tiketId, jenisUser, data) {
  return get(`/tiket/list-user-tiket/${tiketId}/${jenisUser}/'all`, data)
}

function getListUserTiketByUser(tiketId, jenisUser, data) {
  return get(`/tiket/list-user-tiket/${tiketId}/${jenisUser}/self`, data)
}

function getListLinkTiket(tiketId) {
  return get(`/tiket/list-link-tiket/${tiketId}`)
}

function getListRatingTiket(tiketId) {
  return get(`/tiket/list-rating-tiket/${tiketId}`)
}

function approve(tiketId) {
  return post(`/tiket/${tiketId}`)
}

function tolak(tiketId) {
  return post(`/tiket/tolak/${tiketId}`)
}

function insTiket(data) {
  return post('/tiket', data)
}

function uploadFileTiketOld(file, metadata, onUploadProgress) {
  return upload('/tiket/uploadfile', file, metadata, onUploadProgress)
}

function uploadFileTiket(file, metadata, onUploadProgress) {
  return upload('/tiket/uploadfile', file, metadata, onUploadProgress)
}

function insUserTiket(data) {
  return post('/tiket/userTiket', data)
}

function insLinkTiket(data) {
  return post('/tiket/linkKegiatan', data)
}

function updRatingTiket(data) {
  return post('/tiket/ratingKegiatan', data)
}

function delUserTiket(tiketId, UserId, softDelete) {
  return hapus(`/tiket/userTiket/${tiketId}/${UserId}/${softDelete}`)
}

function delLinkTiket(tiketId, LinkId, softDelete) {
  return hapus(`/tiket/linkKegiatan/${tiketId}/${LinkId}/${softDelete}`)
}

function ubahStatusUserTiket(tiketId, UserId, status) {
  return get(`/tiket/ubahStatusUserTiket/${tiketId}/${UserId}/${status}`)
}

function ubahStatusUserTiketMass(data, tiketId, status) {
  return post(`/tiket/ubahStatusUserTiketMass/${tiketId}/${status}`, data)
}

function ubahLinkTiket($data) {
  return update('/tiket/linkKegiatan', $data)
}

function ubahTiket($data) {
  return update('/tiket', $data)
}

function getRoleUser() {
  return get('/tiket/role/user')
}

function downloadDokumenTiket(filename) {
  return download(`/tiket/download/${filename}`)
}

function getKategoriJenisTiketByRoles() {
  return get('/master/kategori-tiket-roles')
}

function getKategoriJenisTiketByKemampuan() {
  return get('/master/kategori-tiket-kemampuan')
}

/* eslint-disable import/prefer-default-export */
export {
  getAllTiket,
  getAllTiketByProyek,
  getAllTiketByUser,
  getAllKegiatanSidebar,
  getAllAplikasi,
  getTiket,
  getUserTiket,
  getListUserTiket,
  getListLinkTiket,
  getListRatingTiket,
  insTiket,
  insUserTiket,
  insLinkTiket,
  updRatingTiket,
  delUserTiket,
  delLinkTiket,
  ubahTiket,
  ubahStatusUserTiket,
  ubahLinkTiket,
  uploadFileTiket,
  ubahStatusUserTiketMass,
  getRoleUser,
  downloadDokumenTiket,
  getAllTiketHistori,
  getKategoriJenisTiketByRoles,
  approve,
  tolak,
  getKategoriJenisTiketByKemampuan,
  getListUserTiketByUser,
}
